var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',{attrs:{"action":_vm.dataObj.host,"data":_vm.dataObj,"format":['jpg','jpeg','png','bmp'],"before-upload":_vm.beforeUpload,"on-success":_vm.handleUploadSuccess,"show-upload-list":false}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }